import React from "react";
import { Box } from "@mui/material";
import ProjectManagement from "./ProjectManagement/ProjectManagement";
import ProjectReview from "./ProjectReview/ProjectReview";
import ProjectUserReview from "./ProjectUser/ProjectUserReview";
import SiteLocationManagement from "./SiteLocation/SiteLocationManagement";
import UOMManagement from "./UOMManagement";
import { GlobalTabCollection, StyledTab } from "../../styles.js";
import ReleaseManagement from "./ReleaseManagement";
import PageUnauthorized from "../../PageUnauthorized";
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";

enum MenuItem {
  SiteLocationManagement = "Site and Location Management",
  ProjectManagement = "Project Management",
  ProjectReview = "Project Review",
  ProjectUserReview = "Project User Review",
  UOMManagement = "Units of Measure",
  ReleaseManagement = "Release Management",
}

const GeneralAdminMenu = () => {
  const [tabValue, setTabValue] = React.useState(MenuItem.SiteLocationManagement);
  
  const { hasAnyRole } = useAuth();
  const developer = hasAnyRole([Roles.Developer]);

  const renderSearchTab = () => {
    switch (tabValue) {
      case MenuItem.SiteLocationManagement: {
        return <SiteLocationManagement />;
      }
      case MenuItem.ProjectManagement: {
        return <ProjectManagement />;
      }
      case MenuItem.ProjectReview: {
        return <ProjectReview />;
      }
      case MenuItem.ProjectUserReview: {
        return <ProjectUserReview />;
      }
      case MenuItem.UOMManagement: {
        return <UOMManagement />;
      }
      case MenuItem.ReleaseManagement: {
        return developer ? <ReleaseManagement /> : <PageUnauthorized />;
      }
      default: {
        alert(tabValue);
      }
    }
  };

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: React.SetStateAction<MenuItem>,
  ) => {
    setTabValue(newValue);
  };

  return (
    <>
      <div>
        <Box sx={{ bgcolor: "#fff" }}>
          <GlobalTabCollection value={tabValue} onChange={handleTabChange} aria-label="ant example">
            {Object.values(MenuItem).map((item) => (
              <StyledTab value={item} label={item} />
            ))}
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default GeneralAdminMenu;
